import mixpanel from "mixpanel-browser"
import { IAnalyticsService } from "./IEventTrackingService"
import { devLogging } from "./common"
import { MixpanelUserProperty } from "./enums"
import { ButtonAttributes, LinkAttributes, PageViewAttributes } from "./interfaces"
import { extractUrlParams } from "../utils"
import { AppClientCodes, isMobileApp } from "../utils/auth.util"

export class MixpanelAnalyticsService implements IAnalyticsService { private static instance: MixpanelAnalyticsService;
    private token: string = process.env.REACT_APP_MIXPANEL_TOKEN || "";
     // Make the constructor private to prevent direct construction calls with the `new` operator.
    private constructor() {

		const { appCode } = extractUrlParams(window.location.search);
		this.token = process.env.REACT_APP_IK_MIXPANEL_TOKEN || '';
		
		if (!this.token) {
		  console.error("Mixpanel not initialized. Token not found.");
		} else if (isMobileApp(appCode as AppClientCodes)) {
		  console.error("Mixpanel initialization skipped for app.");
		} else {
		  this.init();
		}
	  }
	
	  public static getInstance(): MixpanelAnalyticsService {
		if (!MixpanelAnalyticsService.instance) {
			MixpanelAnalyticsService.instance = new MixpanelAnalyticsService();
		}
		return MixpanelAnalyticsService.instance;
	  }
	
	  init(): void {
		mixpanel.init(this.token, { debug: false, persistence: "cookie", cross_subdomain_cookie: true, secure_cookie: true });
		devLogging("Mixpanel initialized.");
	  }
	
	  identifyUser(identifier: { email?: string; deviceId?: string }): void {
		const id = identifier.email || identifier.deviceId;
		if (!id) return;
		mixpanel.identify(id);
		if (identifier.email) mixpanel.people.set({ [MixpanelUserProperty.EMAIL]: identifier.email });
		if (identifier.deviceId) mixpanel.people.set({ [MixpanelUserProperty.DEVICE_ID]: identifier.deviceId });
		devLogging(`Mixpanel identifyUser: ${id}.`);
	  }
	
	  updateUserProperties(properties: Partial<Record<MixpanelUserProperty, string>>): void {
		mixpanel.people.set(properties);
		devLogging("User properties updated.", properties);
	  }
	
	  logEvent(event: string, properties: Record<string, any> = {}): void {
		mixpanel.track(event, properties);
		devLogging(`Event logged: ${event}`, properties);
	  }
	
	  logPageView(attributes: PageViewAttributes): void {
		this.logEvent("Page View", attributes);
	  }
	
	  logButtonClick(attributes: ButtonAttributes): void {
		this.logEvent("Button Click", attributes);
	  }
	
	  logLinkClick(attributes: LinkAttributes): void {
		this.logEvent("Link Click", attributes);
	  }
}

export const mixpanelService = MixpanelAnalyticsService.getInstance();
